export default __webpack_public_path__ + "static/top-8-places-in-the-world-to-treatyourself-paris-c5ba2a0a2d640221c6537c552b23fd75.jpg";